import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Subject, Subscription } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  private idleTimeout = 2 * 60 * 60 * 1000;
  private idleSubject = new BehaviorSubject<boolean>(false);
  idleState = this.idleSubject.asObservable();
  private resetSubject = new Subject<void>();

  private activitySub?: Subscription;
  private debounceSub?: Subscription;

  constructor() {
    // Do NOT start idle detection by default
  }

  startIdleDetection() {
    // Avoid duplicate subscriptions
    this.stopIdleDetection();

    const activityEvents$ = merge(
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'touchstart'),
      fromEvent(document, 'click')
    );

    this.activitySub = activityEvents$.pipe(
      tap(() => this.resetSubject.next())
    ).subscribe();

    this.debounceSub = this.resetSubject.pipe(
      debounceTime(this.idleTimeout),
      tap(() => this.idleSubject.next(true))
    ).subscribe();

    this.resetSubject.next(); // Start detection immediately
  }

  stopIdleDetection() {
    this.activitySub?.unsubscribe();
    this.debounceSub?.unsubscribe();
    this.idleSubject.next(false); // Reset idle state
  }

  resetIdle() {
    this.idleSubject.next(false);
    this.resetSubject.next();
  }
}
